import { u as scrollAnimationsDisabled } from "@theme/utils";
import { t as gsapWithCSS } from "@theme/gsap";
import { t as ensureScrollTrigger } from "@theme/gsap-utils";
//#region frontend/islands/sequence-in-view.js
var SequenceInView = class extends HTMLElement {
	async connectedCallback() {
		const columns = Array.from(this.querySelectorAll(":scope > *"));
		if (!columns.length) return;
		const images = columns.map((col) => col.querySelector("img"));
		if (scrollAnimationsDisabled()) {
			gsapWithCSS.set(columns, {
				opacity: 1,
				visibility: "visible"
			});
			images.forEach((img) => img && gsapWithCSS.set(img, {
				opacity: 1,
				y: 0,
				visibility: "visible"
			}));
			return;
		}
		const ScrollTrigger = await ensureScrollTrigger();
		const once = this.dataset.once !== "false";
		if (once && this._played) {
			gsapWithCSS.set(columns, {
				opacity: 1,
				visibility: "visible"
			});
			images.forEach((img) => img && gsapWithCSS.set(img, {
				opacity: 1,
				y: 0,
				visibility: "visible"
			}));
			return;
		}
		const reset = () => {
			gsapWithCSS.set(columns, {
				opacity: 0,
				visibility: "visible"
			});
			images.forEach((img) => img && gsapWithCSS.set(img, {
				opacity: 0,
				y: 5,
				visibility: "visible"
			}));
		};
		reset();
		const tl = gsapWithCSS.timeline({
			scrollTrigger: {
				trigger: columns[0],
				start: "top 95%",
				toggleActions: once ? "play none none none" : "restart none none none"
			},
			onComplete: once ? () => {
				this._played = true;
			} : void 0
		});
		const stagger = .2;
		const colDuration = 1.2;
		columns.forEach((col, i) => {
			const colStart = i * stagger;
			tl.to(col, {
				opacity: 1,
				visibility: "visible",
				duration: colDuration,
				ease: "power3.out"
			}, colStart);
			const img = images[i];
			if (img) tl.to(img, {
				opacity: 1,
				y: 0,
				visibility: "visible",
				duration: .6,
				ease: "power3.out"
			}, colStart + .15);
		});
		this.animTrigger = tl.scrollTrigger;
		if (!once) this.resetTrigger = ScrollTrigger.create({
			trigger: columns[0],
			start: "top bottom",
			onLeaveBack: reset
		});
	}
	disconnectedCallback() {
		this.animTrigger?.kill();
		this.resetTrigger?.kill();
	}
};
customElements.define("sequence-in-view", SequenceInView);
//#endregion
